/**
 * frontend/src/components/DayOneBadge.jsx
 * SoundDAO Sprint 6-Zero Milestone 4 — Day One badge.
 *
 * SEASON ZERO mechanic. Every account created before the Season One cutoff
 * carries this permanently. The flag is DERIVED server-side from
 * users.created_at (backend/lib/seasonZero.js) — there is no badge table, so
 * nothing needs backfilling when Season One is declared.
 *
 * Rendered in the same inline slot as ScoutBadge, immediately after the name.
 *
 * Props:
 *   dayOne — boolean from the leaderboard row's `day_one` field
 */

import React from 'react';

export default function DayOneBadge({ dayOne }) {
  if (!dayOne) return null;

  return (
    <span
      title="Day One — here before Season One"
      aria-label="Day One member"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        marginLeft: '4px',
        fontSize: '0.62rem',
        fontWeight: 700,
        letterSpacing: '0.04em',
        padding: '1px 6px',
        borderRadius: '999px',
        color: '#f5c451',
        background: 'rgba(245, 196, 81, 0.13)',
        border: '1px solid rgba(245, 196, 81, 0.3)',
        cursor: 'default',
        whiteSpace: 'nowrap',
      }}
    >
      DAY ONE
    </span>
  );
}
